import { ENDPOINT } from '~/constants/endpoints';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { log } from '~/utils/logging';

import {
  type ListParsingCasesParams,
  type PaginatedParsingCasesResponse,
  zodListParsingCasesParamsSchema,
  zodPaginatedParsingCasesResponseSchema,
} from './validations';

/**
 * Fetches a paginated list of parsing cases for the authenticated user's company.
 *
 * @param params - Filter and pagination parameters
 * @param options - Additional request options
 * @returns Paginated list of parsing cases
 * @see https://app.dev.vestigas.com/redoc#tag/Parsing-Cases/operation/list_parsing_cases_delivery_note_parsing_cases_get
 */
export const fetchParsingCases = async (
  params: ListParsingCasesParams,
  options?: KyRequestOptions,
) => {
  const response = await vestigasApi
    .get(ENDPOINT.DELIVERY_NOTE.GET_ALL_PARSING_CASES(), {
      searchParams: params,
      validate: { searchParams: zodListParsingCasesParamsSchema },

      ...options,
    })
    .json<PaginatedParsingCasesResponse>();

  const validatedResponse =
    zodPaginatedParsingCasesResponseSchema.safeParse(response);

  if (validatedResponse?.error?.issues?.length) {
    log.error({
      message: 'Parsing cases list API response has validation errors',
      error: {
        errors: validatedResponse.error.issues,
        errorMessage: validatedResponse.error.message,
        response,
      },
    });
  }

  return response;
};
